import { Redirect } from 'expo-router';
import rdcStrings from 'features/rdc/rdcStrings.en';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import RadioButtonGroup from 'shared/components/vxl/selection/RadioButton/RadioButtonGroup';
import TitleMdText from 'shared/components/vxl/typography/primary/title/TitleMdText';
import { isWeb } from 'shared/constants/platform';
import theme from 'shared/styles/theme';

interface AccountSelectorProps {
  handleAccountSelected: (accountID: string) => void;
  options: { labelText: string; secondaryText?: string; value: string }[];
}

export const AccountSelector = ({
  handleAccountSelected,
  options,
}: AccountSelectorProps) => {
  const handlePress = (value: string) => {
    handleAccountSelected(value);
  };
  if (isWeb) {
    return <Redirect href="/move-money/check-deposit" />;
  }
  return (
    <View style={styles.container}>
      <TitleMdText style={styles.textStyle}>
        {rdcStrings.accountSelectionDrawer.description}
      </TitleMdText>
      <RadioButtonGroup onPress={handlePress} options={options} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: theme.spacing.m,
  },
  textStyle: {
    paddingVertical: theme.spacing.m,
  },
});
